/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberManagementListMemberPointRequest = {
    memberId: number;
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: MemberManagementListMemberPointRequest.direction | null;
};

export namespace MemberManagementListMemberPointRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

